import { cached, peek } from '../lib/cache';
import { normalizeProperty } from '../lib/property';
import { SITE } from '../config/site';
import {
  getCities,
  getOwnerContact,
  getProperties,
  getPropertyDetail,
  getPropertyTypes,
} from './api';

const LONG_TTL = 10 * 60 * 1000;

function cleanFilters(filters = {}) {
  return Object.fromEntries(
    Object.entries(filters)
      .filter(([, value]) => value !== '' && value != null)
      .sort(([a], [b]) => a.localeCompare(b))
  );
}

function propertiesKey(filters) {
  return `properties:${JSON.stringify(cleanFilters(filters))}`;
}

export function fetchProperties(filters) {
  const params = cleanFilters(filters);
  return cached(propertiesKey(params), async () => {
    const data = await getProperties(params);
    if (!Array.isArray(data)) {
      throw new Error('Respuesta invalida de /properties');
    }
    return data.map(normalizeProperty);
  });
}

export function peekProperties(filters) {
  return peek(propertiesKey(filters));
}

export function fetchPropertyDetail(id) {
  return cached(`property:${id}`, async () => normalizeProperty(await getPropertyDetail(id)));
}

export function peekPropertyDetail(id) {
  return peek(`property:${id}`);
}

export function prefetchProperty(id) {
  import('../pages/PropertyDetailPage');
  fetchPropertyDetail(id).catch(() => {});
}

export function fetchCities() {
  return cached('meta:cities', async () => {
    const rows = await getCities();
    return Array.isArray(rows) ? rows : [];
  }, LONG_TTL);
}

export function fetchPropertyTypes() {
  return cached('meta:types', async () => {
    const rows = await getPropertyTypes();
    return Array.isArray(rows) ? rows : [];
  }, LONG_TTL);
}

export function fetchOwner() {
  return cached('meta:owner', async () => {
    try {
      const owner = await getOwnerContact();
      return {
        ownerPhone: owner?.ownerPhone || SITE.fallbackContact.ownerPhone,
        ownerEmail: owner?.ownerEmail || SITE.fallbackContact.ownerEmail,
        ownerWhatsapp: owner?.ownerWhatsapp || SITE.fallbackContact.ownerWhatsapp,
      };
    } catch (_error) {
      return { ...SITE.fallbackContact };
    }
  }, LONG_TTL);
}

export function peekOwner() {
  return peek('meta:owner', LONG_TTL);
}
